import React, { ComponentProps, ReactNode } from 'react';
import {
  FormInput,
  Label,
  IFormInputProps,
  TextInput,
  ITextInputProps,
} from '@grubhubprod/gh-cookbook-react';
import { Control, Controller, RegisterOptions } from 'react-hook-form';

interface CookbookInputWrapperBaseProps {
  name: string;
  control: Control;
  rules?: RegisterOptions;
  error?: IFormInputProps['error'];
  label?: ReactNode;
}

export type CookbookInputWrapperProps = CookbookInputWrapperBaseProps &
  ITextInputProps;

export function CookbookInputWrapper({
  name,
  control,
  rules = {},
  error,
  label = '',
  defaultValue = '',
  ...cookbookInputProps
}: CookbookInputWrapperProps): JSX.Element {
  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      defaultValue={defaultValue}
      render={({ ...field }): JSX.Element => (
        <FormInput
          error={error}
          inputSize={cookbookInputProps.inputSize}
          blockWidth={cookbookInputProps.blockWidth}
        >
          {label && <Label htmlFor={cookbookInputProps.id}>{label}</Label>}
          <TextInput
            {...field}
            {...(cookbookInputProps as ComponentProps<typeof TextInput>)}
          />
        </FormInput>
      )}
    />
  );
}
